export const GRAPH_3540_INTERVAL_INFO = {
  oneHour: 3600000,
  twelveHour: 43200000,
  oneDay: 86400000,
  oneWeek: 604800017,
  oneMonth: 2629800000
};

export const GRAPH_3540_SAMPLING_TIME = {
  oneHour: "ONE_HOUR",
  twelveHour: "TWELVE_HOUR",
  oneDay: "ONE_DAY",
  oneWeek: "ONE_WEEK",
  oneMonth: "ONE_MONTH",
  all: "ALL"
};
